import { useState } from 'react'
import { getClassNameForField, projectCategoriesFields as fields } from '../../constants'
import { EditableFormPage } from '../components/EditableFormPage'
import { useParams } from 'react-router-dom'
import { Button } from '../../shared/components/Button'
import { FaTrash } from 'react-icons/fa'
import { useDeleteItem } from '../../util/deleteItem'
import ConfirmDeleteModal from '../components/DeleteModal'
import { useTranslation } from 'react-i18next'
import { useTranslationService } from '../../util/TranslationContext'

const ProjectCategoriesSlug = () => {
    const [showConfirm, setShowConfirm] = useState(false)
    const { t } = useTranslation()
    const { id } = useParams()

    const { translateFields } = useTranslationService()
    const projectCategoriesFields = translateFields(fields, 'project_categories')

    const deleteItem = useDeleteItem()
    const handleDelete = async () => {
        await deleteItem({
            url: `admin/project-categories/${id}`,
            navigateSuccess: '/admin/auth/project-categories',
            onError: msg => alert(msg),
        })
    }

    return (
        <>
            <div className='flex items-center justify-between'>
                <Button variant='danger' className='mb-4' onClick={() => setShowConfirm(true)}>
                    <FaTrash /> {t('status.delete')}
                </Button>

                <ConfirmDeleteModal
                    isOpen={showConfirm}
                    onClose={() => setShowConfirm(false)}
                    onConfirm={handleDelete}
                />
            </div>
            <EditableFormPage
                fetchUrl={`admin/project-categories/${id}?_method=PUT`}
                fields={projectCategoriesFields}
                classNameForField={getClassNameForField}
            />
        </>
    )
}

export default ProjectCategoriesSlug
